export const SITE = "https://devis-to.be";

export const organization = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE}/#organization`,
  name: "Devisto",
  url: `${SITE}/`,
  logo: { "@type": "ImageObject", url: `${SITE}/assets/devisto-logo.png` },
  slogan: "Dictez la visite, Devisto fait le reste.",
  email: "info@devis-to.be",
  areaServed: { "@type": "Country", name: "Belgique" },
  knowsLanguage: ["fr-BE", "nl-BE"],
  parentOrganization: { "@type": "Organization", name: "JMX Énergie", url: "https://jmx-energie.be", vatID: "BE 0786.236.171" },
});

export const softwareApplication = (lang = "fr") => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "@id": `${SITE}/#software`,
  name: "Devisto",
  url: `${SITE}/`,
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web, iOS, Android",
  inLanguage: ["fr-BE", "nl-BE"],
  description: lang === "nl"
    ? "Offerte- en facturatiesoftware voor vakmensen: spraakdictee, AI-redactie, Peppol-facturatie, planning en werfdossier met foto's."
    : "Logiciel de devis et facturation pour artisans du bâtiment : dictée vocale, rédaction par IA, facturation Peppol, planning et dossier chantier avec photos.",
  offers: { "@type": "Offer", price: "0", priceCurrency: "EUR", name: lang === "nl" ? "Gratis proefperiode" : "Essai gratuit", description: lang === "nl" ? "30 dagen gratis, daarna 25 € excl. btw per maand per bedrijf." : "30 jours gratuits, puis 25 € HTVA par mois et par société.", availability: "https://schema.org/InStock", url: `${SITE}/tarifs` },
  featureList: lang === "nl"
    ? ["Spraakdictee van het plaatsbezoek", "Offerte geschreven door AI", "Peppol-facturatie", "Planning van interventies", "Werfdossier met foto's"]
    : ["Dictée vocale de la visite", "Rédaction du devis par IA", "Facturation Peppol", "Planning d'interventions", "Dossier chantier avec photos"],
  publisher: { "@id": `${SITE}/#organization` },
  screenshot: `${SITE}/assets/shot-quote.webp`,
});

export const faq = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map(({ q, a }) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
});

export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(({ name, path }, i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE}${path}` })),
});

export const article = ({ title, description, path, datePublished, dateModified, image, lang = "fr-BE", wordCount }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description,
  mainEntityOfPage: { "@type": "WebPage", "@id": `${SITE}${path}` },
  image: image ? [image.startsWith("http") ? image : `${SITE}${image}`] : [`${SITE}/og-devisto.jpg`],
  datePublished,
  dateModified: dateModified || datePublished,
  inLanguage: lang,
  wordCount,
  author: { "@type": "Organization", name: "Devisto", url: `${SITE}/` },
  publisher: { "@type": "Organization", name: "Devisto", logo: { "@type": "ImageObject", url: `${SITE}/assets/devisto-logo.png` } },
});
